import React from 'react';
import PropTypes from "prop-types";

export function CsfPivotalFournisseurRecognitionDetailsTab5({formDetail, trainingUfcInfo, allMatiereInfo}) {
  const langcode = document.documentElement.lang;

  return (
      <div className="tab-panel hide" id="recognition-tab" role="tabpanel">
        <div className="tab-line-item d-flex align-items-center">
          <div className="tab-line-title">
            {window.Drupal.t('fournisseur.recognition.detail.subjects.csf')}
          </div>
          <div className="tab-line-value">
            <ul>
              {
                trainingUfcInfo.Cycle_UFC__Secondary && allMatiereInfo.length > 0 &&
                trainingUfcInfo.Cycle_UFC__Secondary.map((val) => {
                  if (val.Asked_UFC !== null && val.Appartenance === 0) {
                    const matchedObject = allMatiereInfo.find(obj => obj.REDU_Subject_Id === val.Subject_Id);
                    return (
                      <li key={val.Subject_Id}>
                        <p>
                          {langcode === 'fr' ? matchedObject.Name_French : matchedObject.Name_English}
                          <span>
                            {val.Duration_Time && (
                              val.Duration_Time +' minutes, '
                            )}
                            {val.Asked_UFC && (
                              val.Asked_UFC +' '+ window.Drupal.t('fournisseur.form.step4.asked.ufc.label')
                            )}
                          </span>
                        </p>
                      </li>
                    );
                  }
                  return null;
                })
              }
            </ul>
          </div>
        </div>

        {formDetail.Submitted_To_Financial_Instit === true && (
        <div className="tab-line-item d-flex align-items-center">
          <div className="tab-line-title">
            {window.Drupal.t('fournisseur.recognition.detail.subjects.iqpf')}
          </div>
          <div className="tab-line-value">
            <ul>
              {
                trainingUfcInfo.Cycle_UFC__Secondary && allMatiereInfo.length > 0 &&
                trainingUfcInfo.Cycle_UFC__Secondary.map((val) => {
                  if (val.Asked_UFC !== null && val.Appartenance === 1) {
                    const matchedObject = allMatiereInfo.find(obj => obj.REDU_Subject_Id === val.Subject_Id);
                    return (
                      <li key={val.Subject_Id}>
                        <p>
                          {langcode === 'fr' ? matchedObject.Name_French : matchedObject.Name_English}
                          <span>
                            {val.Duration_Time && (
                              val.Duration_Time +' minutes, '
                            )}
                            {val.Asked_UFC && (
                              val.Asked_UFC +' '+ window.Drupal.t('fournisseur.form.step4.asked.ufc.label')
                            )}
                          </span>
                        </p>
                      </li>
                    );
                  }
                  return null;
                })
              }
            </ul>
          </div>
        </div>
        )}
      </div>
  );
}

CsfPivotalFournisseurRecognitionDetailsTab5.propTypes = {
  formDetail: PropTypes.object,
  trainingUfcInfo: PropTypes.object,
  allMatiereInfo: PropTypes.array
};
